export default __webpack_public_path__ + "static/media/ElevateYourDrive.5f6a64ee.JPG";